import styled, {DefaultTheme, css} from 'styled-components';

import {mixins} from '../styles';

export {Number} from './Number';
export {SkeletonItem, SkeletonDoughnut, SkeletonCircle} from './Skeleton';
export {H1, H2, H3, H4, H5, HighlightText, ErrorText} from './Typography';
export {Column, Row, Stack, Divider} from './Layout';

export const Paper = styled.div`
  ${mixins.paper}
`;

export const Truncate = styled.div`
  ${mixins.truncate}
`;

export const HiddenInput = styled.input`
  ${mixins.position({position: 'absolute', top: 0, left: 0})}
  ${mixins.wh(0)}
  opacity: 0;
`;

export const Icon = styled.svg<{size?: string; color?: keyof DefaultTheme['palette']}>`
  ${({size}) => mixins.wh(size ?? '18px')}
  ${({color, theme}) =>
    color &&
    css`
      color: ${theme.palette[color]};
    `};
  flex-shrink: 0;
`;
